const {config} = require('../../../package.json');

const alias = (() => {
    return config.serviceProfile ? `/${config.serviceProfile}`: ""
})()

function getApiEndpoint() {
    return (config['isCloudDeployment'] && `https://qa-api.rev-lock.com${alias}`) || "http://localhost:3001"
}

export default {
    microstrategy: {
        mstrWebUrl: "https://qa-reports.rev-lock.com/MicroStrategy/servlet/",
        project: 'QA_RL',
        server: "qa-mstr.cluster.rev-lock.local"
    },
    hotGlue: {
        env_id: "qa.hotglue.rev-lock.com"
    },
    AWS: {
        authenticationFlowType: "USER_PASSWORD_AUTH",
        API: {
            endpoints: [
                {
                    name: "revlock_api",
                    endpoint: getApiEndpoint()
                },
                {
                    name: "revlock_public_api",
                    endpoint: getApiEndpoint(),
                    custom_header: async () => {
                        return {'x-api-key': 'uO5UebKfgDcIlZJh3ec11WX1ScvVhIR8kNoP4Jhe'}
                    }
                }
            ]
        },
        Auth: {
            identityPoolId: "us-east-1:99b004bd-d10b-4384-928a-5ad351ba917f",
            region: "us-east-1",
            userPoolId: "us-east-1_B2k7YxB19",
            userPoolWebClientId: "5n87fc6r53id2nmd0levuddqdj",
            mandatorySignIn: true
        },
        Storage: {
            bucket: 'qa-userfiles',
            region: 'us-east-1',
        },
        Analytics: {
            disabled: true
        },
        oauth: {
            domain: 'qa.auth.rev-lock.com',
            clientId: '1092057117597-naiv1sargrqsilc5n3l6pbef2nclsk16.apps.googleusercontent.com',
            redirectSignOut: 'https://qa.rev-lock.com/signout',
            redirectSignIn: "https://qa.rev-lock.com/",
            scope: ['email', 'profile', 'openid'],
            responseType: "code"
        }
    },
    analytics: {
        trackingId: "UA-127158128-3",
        debug: true
    },

}
